module.exports = __webpack_public_path__ + "img/client1.7d741e3e.png";